// Mirrors the API contract (MINIMUM_SEARCH_TOKEN_LENGTH in
// mako_api/models/data_asset.py): non-regex search terms below the search
// index's ngram(3,3) floor are rejected by the API with a 422, so the UI
// must not fire them.
export const MINIMUM_SEARCH_TOKEN_LENGTH = 3;

export const shortSearchTokens = (
  query: string | null | undefined
): string[] =>
  (query ?? "")
    .trim()
    .split(/\s+/)
    .filter(
      (token) => token.length > 0 && token.length < MINIMUM_SEARCH_TOKEN_LENGTH
    );

export const isSearchQueryTooShort = (
  query: string | null | undefined,
  regex = false
): boolean => !regex && shortSearchTokens(query).length > 0;
